import { SpecialEventValueTypes } from "../SpecialEventsQuery/SpecialEventsQuery.consts";

export const CallRoutingOptions = {
  HANDOFF: {
    key: "HANDOFF",
    eventType: "HANDOFF",
    eventKey: ""
  },
  HANDOFF_REASON: {
    key: "HANDOFF_REASON",
    eventType: "HANDOFF",
    eventKey: "trigger"
  },
  CALL_ROUTED: {
    key: "CALL_ROUTED",
    eventType: "SUCCESSFUL_ROUTE_SELECTION",
    eventKey: ""
  },
  ROUTE_NAME: {
    key: "ROUTE_NAME",
    eventType: "SUCCESSFUL_ROUTE_SELECTION",
    eventKey: "routeName"
  },
  CALL_TRANSFERED: {
    key: "CALL_TRANSFERED",
    eventType: "TRANSFER_DESTINATION_FROM_ROUTING_TABLES",
    eventKey: ""
  },
  TRANSFER_DESTINATION: {
    key: "TRANSFER_DESTINATION",
    eventType: "TRANSFER_DESTINATION_FROM_ROUTING_TABLES",
    eventKey: "transferDestinationFromRoutingTables"
  },
  TRANSFER_REASON: {
    key: "TRANSFER_REASON",
    eventType: "TRANSFER_REASON",
    eventKey: "reason"
  },
  SMS_SENT: {
    key: "SMS_SENT",
    eventType: "SMS_SENT",
    eventKey: ""
  },
  USER_HUNG_UP: {
    key: "USER_HUNG_UP",
    eventType: "USER_HUNG_UP",
    eventKey: ""
  }
};

export const CallRoutingAttributes = {
  [CallRoutingOptions.HANDOFF.key]: {
    type: CallRoutingOptions.HANDOFF.eventType,
    key: CallRoutingOptions.HANDOFF.eventKey,
    label: "Call handed off",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallRoutingOptions.HANDOFF_REASON.key]: {
    type: CallRoutingOptions.HANDOFF_REASON.eventType,
    key: CallRoutingOptions.HANDOFF_REASON.eventKey,
    label: "Handoff reason",
    valueType: SpecialEventValueTypes.DROPDOWN,
    supportsMultiSelect: true
  },
  [CallRoutingOptions.CALL_ROUTED.key]: {
    type: CallRoutingOptions.CALL_ROUTED.eventType,
    key: CallRoutingOptions.CALL_ROUTED.eventKey,
    label: "Call routed",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallRoutingOptions.ROUTE_NAME.key]: {
    type: CallRoutingOptions.ROUTE_NAME.eventType,
    key: CallRoutingOptions.ROUTE_NAME.eventKey,
    label: "Route name",
    valueType: SpecialEventValueTypes.DROPDOWN
  },
  [CallRoutingOptions.CALL_TRANSFERED.key]: {
    type: CallRoutingOptions.CALL_TRANSFERED.eventType,
    key: CallRoutingOptions.CALL_TRANSFERED.eventKey,
    label: "Call transfered",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallRoutingOptions.TRANSFER_DESTINATION.key]: {
    type: CallRoutingOptions.TRANSFER_DESTINATION.eventType,
    key: CallRoutingOptions.TRANSFER_DESTINATION.eventKey,
    label: "Transfer destination",
    valueType: SpecialEventValueTypes.DROPDOWN
  },
  [CallRoutingOptions.TRANSFER_REASON.key]: {
    type: CallRoutingOptions.TRANSFER_REASON.eventType,
    key: CallRoutingOptions.TRANSFER_REASON.eventKey,
    label: "Transfer reason",
    valueType: SpecialEventValueTypes.DROPDOWN
  },
  [CallRoutingOptions.SMS_SENT.key]: {
    type: CallRoutingOptions.SMS_SENT.eventType,
    key: CallRoutingOptions.SMS_SENT.eventKey,
    label: "SMS sent",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallRoutingOptions.USER_HUNG_UP.key]: {
    type: CallRoutingOptions.USER_HUNG_UP.eventType,
    key: CallRoutingOptions.USER_HUNG_UP.eventKey,
    label: "User hung up",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  }
};
